import { BaseService } from "core/services";
import WoundRouteService from "./WoundRouteService";

class WoundService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new WoundRouteService());
    }

    validateDispensingOrder(resource) {
        const url = this.routeService.validateDispensingOrder(resource);
        return this.apiClient.post(url, resource);
    }

    getWoundCalculationResult(resource) {
        const url = this.routeService.getWoundCalculations(resource);
        return this.apiClient.post(url, resource);
    }

    checkDressingCombinations(resource) {
        const url = this.routeService.checkDressingCombinations(resource);
        return this.apiClient.post(url, resource);
    }

    submitDressingCombinations(resource) {
        const url = this.routeService.submitDressingCombinations(resource);
        return this.apiClient.post(url, resource);
    }

    calculateDispensingOrder(resource) {
        const url = this.routeService.calculateDispensingOrder(resource);
        return this.apiClient.post(url, resource);
    }

    getDownloadUrl(resource) {
        return this.apiClient.appOptions.apiUrl + this.routeService.downloadReport(resource);
    }
}

export default WoundService;
